import {
  Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
} from '@triare/auth-redux';
import {
  put, delay, takeLatest, call,
} from 'redux-saga/effects';
import { actions } from './index';

export type BusinessCreateData = { id: string };

export type BusinessCreateResponse = BusinessCreateData

export interface BusinessGoogleMapsInfo {
  placeId: string;
  address: string;
  website: string;
  url: string;
  phoneNumber: string;
  fileUrls: string[];
  openingHoursWeekdayText: string[];
}

export interface BusinessCreateBody {
  name: string;
  description: string;
  address: string;
  country: string;
  city: string;
  state: string;
  phone: string;
  zipCode: string;
  email?: string;
  type: string;
  website: string;
  categoryIds?: string[];
  subCategoryIds?: string[];
  googleMapsInfo: BusinessGoogleMapsInfo;
  fileIds: string[];
  userIds: string[];
}

export const businessCreate = (payload: BusinessCreateBody): Action<BusinessCreateBody> => ({
  type: actions.businessCreateTrigger.toString(),
  payload,
});

export const businessCreateClear = (): Action => ({
  type: actions.businessCreateClear.toString(),
});

export const businessCreateErrorClear = (): Action => ({
  type: actions.businessCreateErrorReset.toString(),
});

export function* businessCreateRequestSaga({ payload }: Action<BusinessCreateBody>) {
  ({ payload });
  yield put({
    type: actions.businessCreateStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.businessCreateError.toString(),
      payload: {
        message: 'BusinessCreate: Parameters not passed.',
      },
    });

    return;
  }

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}businesses`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<BusinessCreateData, BusinessCreateResponse>(
    response,
    actions.businessCreateSuccess.toString(),
    actions.businessCreateError.toString(),
    false,
    (businessCreateData) => businessCreateData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.businessCreateTrigger.toString(),
    defaultProcessingSaga(
      businessCreateRequestSaga,
      {
        error: actions.businessCreateError.toString(),
        locationCancel: actions.businessCreateClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.businessCreateSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }

    // yield put({
    //   type: actions.businessCreateClear.toString(),
    // });
  });

  yield takeLatest(actions.businessCreateError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.businessCreateErrorReset.toString(),
    });
  });
}
